import { AnalyticsService } from './analytics'

import { getUiContext } from '../lib/uiAnalyticsContext.js'

export function trackUiEvent(event, properties = {}) {
    AnalyticsService.track(event, { ...getUiContext(window.location.pathname), ...properties })
}

// One launch event for Open with / Ask with / Ask and direct prompt CTAs.
// Do not send prompt text, API tokens, or report filter contents here.
export function trackAiOpen(properties) {
    trackUiEvent('ai-open-clicked', properties)
}
